import React, { useEffect } from 'react'
import { GRADES, TOPICS } from 'utils'
import { useApprovedQuestionTemplatesCount, useRejectedQuestionTemplatesCount, useQuestionTemplatesCount } from './CurateQuestionsPage';
import Spinner from 'components/Spinner';

type Props = {}


function GradeTopic({ grade, topic }) {
    const { data: approvedCount = 0, isLoading: isLoadingApprovedCount } = useApprovedQuestionTemplatesCount(grade, topic);
    const { data: rejectedCount = 0, isLoading: isLoadingRejectedCount } = useRejectedQuestionTemplatesCount(grade, topic);
    const { data: totalCount = 0, isLoading: isLoadingTotalCount } = useQuestionTemplatesCount(grade, topic)

    let isLoading = isLoadingApprovedCount || isLoadingRejectedCount || isLoadingTotalCount

    let pendingReviewCount = totalCount - approvedCount - rejectedCount

    return <tr className='tr'>
        <td>
            {isLoading && <Spinner className='d-inline-block mr-2' />}
            <div className="d-inline-block">
                {topic}
            </div>
        </td>
        <td style={{ whiteSpace: "nowrap" }}>
            <span className='tag is-success is-light'>
                {approvedCount}
            </span>
        </td>
        <td>
            <span className="tag is-danger is-light">
                {rejectedCount}
            </span>
        </td>
        <td>
            <span className="tag is-warning is-light">
                {pendingReviewCount}
            </span>
        </td>

    </tr>
}

function GradeCard({ grade }) {
    return (
        <div className='column mr-3 mt-3'>
            <strong>{grade}</strong>
            <table className='table card'>
                <tbody>
                    {TOPICS.map(t => <GradeTopic
                        key={grade + t.topic}
                        grade={grade}
                        topic={t.topic} />)}
                </tbody>
            </table>
        </div>
    )
}


export default function CuratedStats({ }: Props) {
    return (
        <div>
            <div className='ml-3 my-5'>
                <span className='tag is-success is-light mr-3'>
                    Approved
                </span>
                <span className='tag is-danger is-light mr-3'>
                    Rejected
                </span>
                <span className='tag is-warning is-light'>
                    Pending Review
                </span>
            </div>
            <div className='columns ml-3' style={{ flexWrap: "wrap", height: "100vh", overflow: "auto" }}>
                {GRADES.map(g => {
                    return <GradeCard key={g.value} grade={g.value} />
                })}
            </div>
        </div>

    )
}